import {
  QueryAnnouncementsArgs,
  MutationDismissAnnouncementArgs,
} from '../../generated';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { token } from '@trello/session-cookie';
import { clientVersion } from '@trello/config';

export const announcementsResolver = async (
  _parent: unknown,
  args: QueryAnnouncementsArgs,
  _context: unknown,
  info: QueryInfo,
) => {
  const apiUrl =
    args && args.filter === 'all' ? '/announcements/all' : '/announcements';
  const response = await fetch(apiUrl, {
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    credentials: 'include',
  });
  const announcements = await response.json();

  return prepareDataForApolloCache(announcements, info);
};

export const dismissAnnouncement = async (
  _obj: object,
  args: MutationDismissAnnouncementArgs,
  _context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/announcements/dismiss`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Trello-Client-Version': clientVersion,
    },
    body: JSON.stringify({
      id: args.announcementId,
      token,
    }),
    credentials: 'include',
  });

  return prepareDataForApolloCache({ success: response.ok }, info);
};
